import React from 'react';
import PropTypes from 'prop-types';
import { connectToUser } from '../User/containers/UserDataStore';

export class LocalizedDate extends React.Component {
	static propTypes = {
		dateString: PropTypes.string,
		dateFormat: PropTypes.string,
		userStore: PropTypes.object,
	};

	static defaultProps = {
		dateFormat: 'MMDDYYFormat',
	};

	render() {
		const { dateString, dateFormat, userDataStore } = this.props;
		return (
			<span>
				{dateString && dateString !== '0001-01-01T00:00:00'
					? new Date(dateString).toLocaleDateString(
							this.getCultureIndicator(userDataStore),
							dateFormat,
					  )
					: '-'}
			</span>
		);
	}

	getCultureIndicator(userDataStore) {
		const country =
			userDataStore.state.organization &&
			userDataStore.state.organization.address
				? userDataStore.state.organization.address.country
				: 'US';
		if (country === 'UK' || country === 'GB') {
			return 'en-GB';
		} else {
			return 'en-US';
		}
	}
}

export default connectToUser(LocalizedDate);
